import Link from '@/components/link-component'
import PageWrapper from '../components/page-wrapper'

import routes from '../constants/routes'

export default function NotFound({ headerNav, footerNav, newsletterForm }) {
  return (
    <PageWrapper
      headerNav={headerNav}
      footerNav={footerNav}
      newsletterForm={newsletterForm}
      seo={{ fields: { title: 'Page Not Found' } }}
      bodyTw="bg-indigoBlue"
    >
      <div className="max-w-8xl mx-auto py-14 px-5 lg:px-9">
        <div className="flex lg:justify-end bg-[url('https://images.ctfassets.net/7rncvj1f8mw7/3hFwAbRp0pdfStyL1jNUXW/3713a16599af668b2d36d4472a1c6540/security-cellar-new.svg')] bg-contain bg-no-repeat bg-center  min-h-[360px] lg:min-h-[690px] items-center">
          <div className="text-white lg:w-1/2">
            <p className="text-2xl lg:text-4xl mb-0">Uh oh.</p>
            <h1 className="text-[120px] my-0">404</h1>
            <p className="text-2xl lg:text-4xl">
              It seems you have stumbled into an empty vault. The way out is easy – return to our{' '}
              <Link to={routes.index} className="text-accent-teal">
                home page
              </Link>{' '}
              {'or'}{' '}
              <Link to={routes.contact} className="text-accent-teal">
                contact us
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}
